export class wellnessSurveyAnswer {
  
    public surveyQuestionId: number = 0;
    public surveyQuestionAnswer: string = "";
  }
export class AssessmentAnswer {

  public QuestionId: number = 0;
  public Answer: string = "";
  public AnswerDetails: string = "";
}
  